/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

export const ENDPOINTS = {
	ADMIN_API: "",
	SHARED_API: process.env.REACT_APP_SHARED_API_URL,
	ACVM_API: "",
	WEB_CHAT_CF: "",
	CALL_ME_NOW_CF: "",
};

export const setEndpoints = (endpoints) => {
	Object.keys(endpoints).forEach((key) => {
		ENDPOINTS[key] = endpoints[key];
	});
};
